import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import FeaturedCollections from '../components/FeaturedCollections';
import Gallery from '../components/Gallery';

const HomePage: React.FC = () => {
  return (
    <div className="overflow-x-hidden">
      <Hero />
      <Features />
      <FeaturedCollections />
      <Gallery />
    </div>
  );
};

export default HomePage;
